import type { PrimaryPalette } from '~/domain/shared/branding/models/PrimaryPalette'

export const CplugPrimaryPalette: PrimaryPalette = {
  50: '#e0f2fe',
  100: '#bae6fd',
  200: '#7dd3fc',
  300: '#38bdf8',
  400: '#0ea5e9',
  500: '#0091e6',
  600: '#0284c7',
  700: '#0369a1',
  800: '#075985',
  900: '#0c4a6e',
  950: '#082f49'
}
